import uuid from 'uuid/v4';

export default () => uuid();

export const short_uuid = () => uuid().split('-').join('');
